module.exports = __webpack_public_path__ + "static/img/tu7.16c431b1.png";